import { CloudResourceRules } from '../EntityPages';

export const CloudResourceRulesTab = () => {
  return <CloudResourceRules />;
};
